import React, { Component } from 'react';
import Inherit from '../../../core/inherit';
import PriceListController from './list.controller';
import withNavigate from '../../../core/withNavigate';
import { ReceiptText, CalendarClock, TriangleAlert } from 'lucide-react';

import { Layout, Loading, PageHeader, StatusTag, EmptyState } from '../../common';
import { CreateListForm, PriceList, PriceStoreControls } from './elements';
import { fmtVZ } from '../../../utils/timeUtils';

class ShelfPriceList extends Inherit(PriceListController, Component) {
    state = {
        loading: true,
        priceList: [],
        storeType: {},
        file: null,
        products: [],
        clients: [],
        channel: 'tradicional',
        converted: false,
        canManageOverrides: false,
        viewMode: 'default',
        clientStores: [],
        storeListIds: new Set(),
        selectedStoreId: null,
        hasStoreList: false,
        hasStoreSegmentation: false,
        deleting: false
    };

    render() {
        const {
            priceList,
            channel,
            clients,
            storeType,
            products,
            converted,
            loading,
            canManageOverrides,
            viewMode,
            clientStores,
            storeListIds,
            selectedStoreId,
            hasStoreList,
            hasStoreSegmentation,
            deleting
        } = this.state;
        const canOverride = canManageOverrides && !storeType?.message && storeType?.channel === 'moderno';
        const showList = !storeType?.message && storeType && (viewMode === 'default' || selectedStoreId);
        const id = this.props.searchParams.get('id');
        const hasList = !storeType?.message && !!storeType;

        return (
            <Layout>
                {loading ? (
                    <Loading />
                ) : (
                    <>
                        <PageHeader
                            icon={<ReceiptText />}
                            title={hasList ? `Lista de precio: ${storeType?.label}` : 'Crear Lista de Precio'}
                            description={hasList ? 'Modifica los precios de los productos' : 'Configura una nueva lista de precios'}
                            meta={
                                hasList && priceList?.createdAt ? (
                                    <StatusTag icon={<CalendarClock />}>
                                        Lista vigente desde: {fmtVZ(priceList.createdAt, 'DD/MM/YYYY HH:mm')}
                                    </StatusTag>
                                ) : null
                            }
                        />
                        {!id && (
                            <CreateListForm
                                channel={channel}
                                clients={clients}
                                storeType={storeType}
                                setChannel={this.setChannel.bind(this)}
                                fetchStoreType={this.fetchStoreType.bind(this)}
                            />
                        )}
                        {storeType?.message && (
                            <div className="shelf-card mx-auto mt-6 max-w-xl">
                                <EmptyState
                                    tone="danger"
                                    icon={<TriangleAlert />}
                                    title="Segmentación de Productos Requerida"
                                    description="Primero se debe crear la segmentación de productos para poder crear una lista de precio. Por favor, configura la segmentación de productos antes de continuar."
                                />
                            </div>
                        )}
                        {canOverride && (
                            <PriceStoreControls
                                viewMode={viewMode}
                                setViewMode={this.onViewModeChange.bind(this)}
                                stores={clientStores}
                                selectedStoreId={selectedStoreId}
                                setSelectedStoreId={this.onStoreSelect.bind(this)}
                                storeListIds={storeListIds}
                                hasStoreList={hasStoreList}
                                hasStoreSegmentation={hasStoreSegmentation}
                                onDelete={() => this.deleteStoreList()}
                                deleting={deleting}
                            />
                        )}
                        {showList && (
                            <PriceList
                                key={selectedStoreId || 'client'}
                                handleConvert={this.handleConvert.bind(this)}
                                products={products}
                                storeType={storeType}
                                setProducts={this.setProducts.bind(this)}
                                priceList={priceList}
                                converted={converted}
                                createPriceList={this.createPriceList.bind(this)}
                            />
                        )}
                    </>
                )}
            </Layout>
        );
    }
}

export default withNavigate(ShelfPriceList);
